export default {
  SET_USER (state, user) {
    state.user = user
  },
  SET_TOKEN (state, token) {
    state.token = token
  },
  SET_REFRESHTOKEN (state, refreshToken) {
    state.refreshToken = refreshToken
  },
  SET_MESSAGE (state, message) {
    state.message = message
  },
  SET_SETTINGPARAMS (state, settingParams) {
    state.settingParams = settingParams
  },
  SET_SHOWSTARTGUIDE (state, showStartGuide) {
    state.showStartGuide = showStartGuide
  },
  SET_LOCALE (state, locale) {
    state.locale = locale
  },
  SET_LOGOUTPAGE (state, path) {
    state.logoutPage = path
  },
  SET_SERVICELIST (state, params) {
    state.serviceList = {
      longNames: params.long,
      shortNames: params.short,
      codes: params.code
    }
  },
  SET_WATERSYSTEM_DISPLAYMODE (state, mode) {
    state.waterSystemDisplayMode = mode
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js